import { Component } from '@angular/core';
import '@vanguard/ocean-platform-window-events';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {}
